import {Component, Input} from "@angular/core";

@Component({
    selector : 'loading',
    template: require('./loading.component.html')
})

export class LoadingComponent {
    @Input()
    loadingMessage: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/loading.component.ts